const socialMediaItems = [
  {
    id: "11",
    name: "Facebook",
    icon: "facebook",
    profileURL: "https://www.facebook.com/sunil.sivadassachu/",
  },
  {
    id: "12",
    name: "Twitter",
    icon: "twitter",
    profileURL: "https://twitter.com/sunildas_ssd",
  },
  {
    id: "13",
    name: "LinkedIn",
    icon: "linkedin",
    profileURL: "https://www.linkedin.com/in/sunildas-s-3a1293103/",
  },
  {
    id: "21",
    name: "Telegram",
    icon: "paper-plane",
    profileURL: "https://t.me/sunil_sivadas",
  },
  {
    id: "22",
    name: "Email",
    icon: "envelope",
    profileURL: "mailto:sunildasssd25@gmail.com",
  },
];

export default socialMediaItems;
